export const usePaginationContent = () => ({
  summaryTitle: 'pagination-summary-title',
  goUpTitle: 'pagination-go-up-title',
  nextTitle: 'pagination-next-title',
  previousTitle: 'pagination-previous-title',
})
